import { render, staticRenderFns } from "./grondverzetPopup.vue?vue&type=template&id=022188ee&scoped=true"
import script from "./grondverzetPopup.vue?vue&type=script&lang=js"
export * from "./grondverzetPopup.vue?vue&type=script&lang=js"
import style0 from "./grondverzetPopup.vue?vue&type=style&index=0&id=022188ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022188ee",
  null
  
)

export default component.exports